<template>
  <div v-bind:class="'label-situacao theme-' + (theme || 'default')">
    <md-icon v-if="icon">{{icon}}</md-icon>
    <span>{{text}}</span>
  </div>
</template>

<script>
  export default {
    name: 'Label',
    props: {
      text: String,
      theme: String,
      icon: String
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .label-situacao {
    display: block;
    font-size: 16px;
    border-radius: 5px;
    text-align: left;
    padding-left: 16px;
  }

    .label-situacao i {
      min-width: 14px;
      color: white !important;
      font-size: 18px !important;
      width: auto;
    }

    .label-situacao span {
      width: auto;
      padding-left: 16px;
      display: inline-block;
      vertical-align: sub;
    }

  .theme-default {
    background-color: #EEF2F6;
    color: white !important;
  }

    .theme-default > span {
      color: white !important;
    }

  .theme-primary {
    background-color: #6361FB;
    color: white !important;
  }

    .theme-primary > span {
      color: white !important;
    }

  .theme-success {
    background-color: #009688;
    color: white !important;
  }

    .theme-success > span {
      color: white !important;
    }

  .theme-danger {
    background-color: #FF0000;
    color: white !important;
  }

    .theme-danger > span {
      color: white !important;
    }

  .theme-warning {
    background-color: #FFB300;
    color: white !important;
  }

    .theme-warning > span {
      color: white !important;
    }
</style>
